module.exports = __webpack_public_path__ + "fb04ae47c0782526c3483fe2816128f0.png";